import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const rapidboardUserReportRoute: InvariantJiraRoute = {
	name: 'rapidboard-user-report',
	path: '/jira/people/:accountId/boards/:boardId/reports/:chartView',
};
